var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-dialog",
    {
      attrs: {
        title: _vm.$t("pc_gwnl_global_all_train").d("全部测评"),
        visible: _vm.evalVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.evalVisible = $event
        },
      },
    },
    _vm._l(_vm.evalList, function (item, index) {
      return _c(
        "div",
        {
          key: item.evaluationId + index,
          staticClass: "item pt20 pb20 pl24 pr24",
        },
        [
          _c(
            "div",
            { staticClass: "standard-size-16 font-weight-500 lh24 ml-6" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.evalName(
                      item.evalType,
                      item.evaluationName || item.evalName
                    )
                  ) +
                  "\n      "
              ),
              item.importType === 1
                ? _c(
                    "yxt-tag",
                    {
                      staticClass: "ml8",
                      attrs: { size: "mini", type: "info" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("pc_gwnl_global_import_eval")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "flex align-items-center mt12" }, [
            item.importType !== 1
              ? _c("div", { staticClass: "lh22 txt gwnl-eval-dialog__left" }, [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          " " + _vm.$t("pc_gwnl_eval_evalRelationship") + "："
                        ) +
                        "\n        "
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.info[item.evalPattern]) +
                        "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              [
                _c("span", { staticClass: "lh22 txt" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("pc_gwnl_eval_evalProgress") + "：") +
                      "\n        "
                  ),
                ]),
                _c("yxtf-progress", {
                  attrs: {
                    percentage: _vm._f("numberFormatter")(
                      item.evaluationFinishRate
                    ),
                  },
                }),
              ],
              1
            ),
          ]),
          item.startTime || item.endTime
            ? _c("div", { staticClass: "lh22 txt mt8" }, [
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_gwnl_eval_lbl_evalTime") + "：") +
                      "\n      "
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        item.startTime && _vm.formatDateMd(item.startTime)
                      ) +
                      "\n        ~\n        " +
                      _vm._s(item.endTime && _vm.formatDateMd(item.endTime)) +
                      "\n      "
                  ),
                ]),
              ])
            : _vm._e(),
          item.evalPattern === 1
            ? _c(
                "div",
                [
                  (item.lockStatus !== 1 && _vm.showAttendToast(item) === "") ||
                  item.evaluationStatus === 4
                    ? _c(
                        "yxtf-button",
                        {
                          staticClass: "btn-eval",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toEval(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                item.evaluationFinishRate === 100 ||
                                  item.evaluationStatus === 4
                                  ? _vm.$t("pc_gwnl_web_homework_btn_toView")
                                  : _vm.$t("pc_gwnl_web_toEvaluate")
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          item.evalPattern === 3
            ? _c(
                "div",
                [
                  item.lockStatus !== 1 && _vm.showAttendToast(item) === ""
                    ? _c(
                        "yxtf-button",
                        {
                          staticClass: "btn-eval",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toEval(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                item.selfFinishedStatus === 1
                                  ? _vm.$t("pc_gwnl_web_homework_btn_toView")
                                  : _vm.$t("pc_gwnl_web_toEvaluate")
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          item.evalPattern !== 2 &&
          item.evaluationStatus !== 4 &&
          item.importType !== 1
            ? _c(
                "div",
                [
                  item.lockStatus === 1 || _vm.showAttendToast(item) !== ""
                    ? _c(
                        "yxtf-popover",
                        {
                          attrs: {
                            placement: "top-start",
                            trigger: "hover",
                            "visible-arrow": true,
                            content: _vm.showAttendToast(item),
                          },
                        },
                        [
                          _c(
                            "yxtf-button",
                            {
                              staticClass: "btn-eval dis-btn",
                              attrs: { slot: "reference", type: "primary" },
                              slot: "reference",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("pc_gwnl_web_toEvaluate")) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : item.evalPattern === 2 && item.importType !== 1
            ? _c(
                "div",
                {
                  staticClass: "btn-eval lh22",
                  class: {
                    "other-txt": item.evaluationFinishRate !== 100,
                    txt: item.evaluationFinishRate === 100,
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        item.evaluationStatus === 4 &&
                          item.evaluationFinishRate !== 100
                          ? _vm.$t("pc_gwnl_global_over")
                          : item.evaluationFinishRate === 100
                          ? _vm.$t("pc_gwnl_training_other_finished")
                          : _vm.$t("pc_gwnl_training_other_people")
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          item.importType === 1
            ? _c("div", { staticClass: "font-size-14 text-8c btn-eval" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("pc_gwnl_global_completed")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }